import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Divider,
  FormLabel,
  Grid,
  IconButton,
  Radio,
  setRef,
  TableContainer,
  TableHead,
} from "@mui/material";
import UndoIcon from "@mui/icons-material/Undo";
import Checkbox from "@mui/material/Checkbox";
import { FeTextField, FeAutocomplete } from "../../../FormElements";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";

import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import { isEmpty, set } from "lodash";
import { updateObjectValue } from "../../../../utils/helper";
import FeDesktopDatePicker from "../../../FormElements/FeDesktopDatePicker";
import dayjs from "dayjs";
import doctorAPI from "../../../../utils/doctorAPI";

const radioOptions = ["positive", "negative", "not_done"];
const IHCForm = ({ onStateChange, editedObj, updatedObj }) => {
  const [obj, setObj] = useState({
    date: null,
    ihc_details: [],
  });
  const [rows, setRows] = useState([]);
  useEffect(() => {
    getRows(updatedObj, editedObj);

    return () => {};
  }, [updatedObj, editedObj]);

  function createIHCObject(keysArray) {
    // Create an object with keys from the array and all values set to null
    const arr = [];

    keysArray.forEach((key) => {
      const ihcObject = {
        type: key.toLowerCase(),
        value: null,
      };
      arr.push(ihcObject);
    });

    return arr;
    // Return the final structure inside the ihcs array
    // return ihcObject;
  }

  const getRows = async (updatedObj, editedObj) => {
    const { data } = await doctorAPI.get("doctor/ihc-records-all");
    setRows(data.data);
    const names = data.data.map((d) => d.name);
    const result = createIHCObject(names);

    const obj = {
      date: null,
      ihc_details: result,
    };

    // setObj(obj);
    let u = null,
      e = null;
    if (updatedObj) {
      u = updateObjectValue(obj, updatedObj);
    }
    if (editedObj) {
      e = editedObj;
    }

    if (u) {
      setTimeout(() => {
        setObj(u);
      }, 100);
      return;
    } else if (!u && e) {
      if (e.ihc_details.length === 0) {
        setObj({
          date: null,
          ihc_details: result,
        });
        return;
      }

      setTimeout(() => {
        setObj({
          date: e.date,
          ihc_details: mergeArrays(
            e.ihc_details.map((d) => {
              return { type: d.type, value: d.value || null };
            }),
            result
          ),
        });
      }, 100);
    } else if (!u && !e) {
      setObj({
        date: null,
        ihc_details: result,
      });
    }
  };

  function mergeArrays(array1, array2) {
    // Create a map of array1 for quick look-up by id
    const array1Map = array1.reduce((map, obj) => {
      map[obj.type] = obj;
      return map;
    }, {});

    // Merge array2 into array1, keeping array1's values if id conflicts
    return [...array1, ...array2.filter((obj) => !array1Map[obj.type])];
  }

  const handleChangeRadioBox = (e, index) => {
    const { name, value } = e.target;

    console.log("value", value, name, index);
    const list = [...obj.ihc_details];
    console.log("existing", list);

    const updatedList = list.map((p) =>
      p.type === name ? { ...p, value } : p
    );

    // setObj({ ...obj, ih: list });
    setObj({ ...obj, ihc_details: updatedList });
  };

  useEffect(() => {
    if (!isEmpty(obj)) onStateChange(obj);
  }, [obj]);

  console.log("AAAAxxcx", obj);

  return (
    <>
      <Grid item xs={12} md={12}>
        <Box mb={2}>
          <FeDesktopDatePicker
            //  disabled={editedObj}
            label="Date"
            inputFormat="DD/MM/YYYY"
            value={obj.date}
            onChange={(v) => {
              const date = dayjs(v).format("YYYY-MM-DD");

              setObj({ ...obj, date });
              // setObj({ ...obj, ihcs[0].date: date });
            }}
          />
          <TableContainer
            component={Paper}
            sx={{
              boxShadow: "none",
              border: "1px solid rgba(0, 0, 0, 0.23)",
              maxHeight: 360,
            }}
          >
            <Box py={1.5} pl={2}>
              <FormLabel>IHC</FormLabel>
            </Box>
            <Table
              size="small"
              stickyHeader
              sx={{
                borderTop: "1px solid rgba(0, 0, 0, 0.23)",
                "& tr": {
                  "&:last-child": {
                    "& td": {
                      borderBottom: 0,
                    },
                  },
                },
              }}
            >
              <TableHead>
                <TableRow>
                  <TableCell>Undo</TableCell>
                  <TableCell>Name</TableCell>
                  <TableCell align="center">Positive</TableCell>
                  <TableCell align="center">Negative</TableCell>

                  <TableCell align="center">Not Done</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.length > 0 &&
                  rows.map((row, index) => (
                    <TableRow key={index}>
                      <TableCell component="th" scope="row">
                        <IconButton
                          type="button"
                          onClick={() => {
                            const ihc_details = [...obj.ihc_details];
                            const updatedList = ihc_details.map((p) =>
                              p.type === row.name.toLowerCase()
                                ? { ...p, value: null }
                                : p
                            );

                            setObj({
                              ...obj,
                              ihc_details: updatedList,
                            });
                          }}
                          color="primary"
                          aria-label="add to shopping cart"
                        >
                          <UndoIcon />
                        </IconButton>
                      </TableCell>
                      <TableCell component="th" scope="row">
                        {row.name}
                      </TableCell>

                      {radioOptions.map((item, i) => (
                        <TableCell key={i} align="center">
                          {obj.ihc_details.length > 0 && (
                            <Radio
                              checked={
                                obj.ihc_details.filter(
                                  (d) => d.type === row.name.toLowerCase()
                                )[0]?.value === item
                              }
                              //  disabled={editedObj}
                              onChange={(e) => handleChangeRadioBox(e, index)}
                              value={item}
                              name={row.name.toLowerCase()}
                            />
                          )}
                        </TableCell>
                      ))}
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Grid>
    </>
  );
};

export default IHCForm;
